// src/components/MarkdownRenderer/MarkdownRenderer.jsx

import React from "react";
import ReactMarkdown from "react-markdown";
import he from "he";

const MarkdownRenderer = ({ content }) => {
  // 1. Décodage des entités HTML
  const decoded = he.decode(content || "");

  function fixFrenchPunct(text) {
    return text
      .replace(/\s([!?:;»])/g, '\u202F$1') // avant ! ? : ; »
      .replace(/«\s/g, '«\u202F');         // après «
  }

  return <ReactMarkdown>{fixFrenchPunct(decoded)}</ReactMarkdown>;
};

export default MarkdownRenderer;
